import { Box, Typography } from '@mui/material';
import { CommaListField } from 'framework/ui/field';
import { AssignmentFormItem } from 'domain/shared/compliance';
import { ReactNode } from 'react';

type PreviewFieldProps<T> = {
  label: string;
  value?: T;
  isAll: boolean;
  renderValue: (value: T | undefined) => ReactNode;
};

export const PreviewField = <T,>({ label, value, isAll, renderValue }: PreviewFieldProps<T>) => (
  <Box display="flex" mb={1}>
    <Typography color="primary">{label}:&nbsp;</Typography>
    <Typography>{isAll ? (value as ReactNode) : renderValue(value)}</Typography>
  </Box>
);

export const AssignmentsPreviewValue = ({ assignments }: { assignments?: AssignmentFormItem[] }) => (
  <CommaListField
    value={assignments || []}
    isNeedJoin={false}
    mapValue={(assignment: AssignmentFormItem) => (
      <Typography>
        {assignment.name}
        {assignment.account ? ` (${assignment.id})` : ''}
      </Typography>
    )}
  />
);
